// Enums
export enum ConnectionType {
  SIGNAL = "SIGNAL",
  CAUSE = "CAUSE",
  ACTION = "ACTION",
  INTERNAL = "INTERNAL"
}

export enum SaslMechanismPlainText {
  plain = "plain"
}

export enum SaslMechanismSSL {
  gssapi = "gssapi",
  oauthBearer = "oauthBearer",
  scramSha256 = "scramSha256",
  scramSha512 = "scramSha512"
}

export enum FileType {
  csv = "csv",
  json = "json",
  jsonl = "jsonl",
  parquet = "parquet"
}

export enum Deserializer {
  JSON = "JSON",
  AVRO = "AVRO",
  PROTO = "PROTO"
}

// Base interfaces
export interface TraceInfo {
  [key: string]: any;
}

// File Source Config
export interface HTTPSource {
  url: string;
}

export interface GCSSource {
  serviceAccountJson: string;
  bucket: string;
  path: string;
  filePattern: string;
}

export interface BlobSource {
  namespace: string;
  path: string;
  filePattern: string;
}

export interface FileSourceConfig {
  fileType: FileType;
  http?: HTTPSource;
  gcs?: GCSSource;
  upload?: BlobSource;
  options: Record<string, string>;
}

// JDBC Source Config
export interface MySQL {
  useSSL: boolean;
}

export interface EncryptedVerify {
  hostNameInCertificate: string;
}

export interface MSSQL {
  unEncrypted?: boolean;
  encryptedTrust?: boolean;
  encryptedVerify?: EncryptedVerify;
}

export interface JDBCSourceConfig {
  host: string;
  port: number;
  database: string;
  username: string;
  password: string;
  mysql?: MySQL;
  mssql?: MSSQL;
  tablePattern: string;
  options: Record<string, string>;
}

// Kafka Source Config
export interface SaslPlainText {
  saslMechanism: SaslMechanismPlainText;
  saslJAASConfig: string;
}

export interface SaslSSL {
  saslMechanism: SaslMechanismSSL;
  saslJAASConfig: string;
  sslTrustStoreCertContent: string;
  sslTrustStorePassword: string;
}

export interface SchemaRegistry {
  deserializer: Deserializer;
  registryUrl: string;
  basicAuthUserInfo: string;
  basicAuthCredentialsSource: string;
}

export interface KafkaSourceConfig {
  bootstrapServer: string[];
  plaintext?: boolean;
  saslPlaintext?: SaslPlainText;
  saslSSL?: SaslSSL;
  topicPattern: string;
  schemaConfig?: SchemaRegistry;
  options: Record<string, string>;
}

// Connection Config
export interface ConnectionConfig {
  connectionType: ConnectionType;
  fileSource?: FileSourceConfig;
  jdbcSource?: JDBCSourceConfig;
  kafkaSource?: KafkaSourceConfig;
}

export interface AddConnectionRequest {
  traceInfo?: TraceInfo;
  connectionConfig: ConnectionConfig;
}

export interface AddConnectionResponse {
  traceInfo?: TraceInfo;
  connectionId: string;
  error: string;
}

export interface JobStatusResponse {
  jobId: string;
  jobStatus: JobStatus;
  timeRange: TenantDataTimeRange;
  eventsFailed: number;
  eventsProcessed: number;
  eventsDropped: number;
  tablesProcessed: number;
  dataQualityScore: number;
  progress: number;
}

export type TenantDataTimeRange = {
  timeRange: {
    startTimeMillis: number;
    endTimeMillis: number;
  };
  eventTypeVsTimeRange: Record<
    string,
    {
      startTimeMillis: number;
      endTimeMillis: number;
    }
  >;
};

export enum JobStatus {
  UNKNOWN = "UNKNOWN",
  DATA_PROCESSING_INPROGRESS = "DATA_PROCESSING_INPROGRESS",
  DATA_PROCESSSING_DONE = "DATA_PROCESSSING_DONE",
  DATA_PROCESSING_FAILED = "DATA_PROCESSING_FAILED",
  DATA_LOADING = "DATA_LOADING",
  DATA_LOADING_DONE = "DATA_LOADING_DONE",
  DATA_LOADING_FAILED = "DATA_LOADING_FAILED"
}
